import { NavLink } from 'react-router-dom';
import { Grid, Image, Menu } from 'semantic-ui-react';

import Dragonfly_Logo from '../../assets/Dragonfly_Advise_logo.svg';
import LOGO_BANNER_BG from '../../assets/logo_bnnr_bg.png';

const SSOHeader = () => {
  return (
    <Menu
      inverted
      attached
      className='app-header borderless'
      style={{
        marginBottom: '25px',
        backgroundColor: 'transparent',
        display: 'flex',
      }}
    >
      <Grid style={{ width: '100vw' }}>
        <img
          src={LOGO_BANNER_BG}
          style={{
            position: 'absolute',
            left: '0px',
            top: '0px',
            zIndex: '10',
          }}
          alt=''
        />
        <Grid.Row
          style={{
            background: `linear-gradient(90.04deg, #00355a 44.15%, #1279c9 91.67%)`,
            height: '75px',
            marginTop: '1rem',
          }}
        >
          <Menu.Item>
            <NavLink to='/'>
              <Image
                style={{ display: 'inline', paddingLeft: '65px', zIndex: '10' }}
                src={Dragonfly_Logo}
              />
            </NavLink>
          </Menu.Item>
        </Grid.Row>
      </Grid>
    </Menu>
  );
};

export default SSOHeader;
